module.exports = __webpack_public_path__ + "media/luxury-2026/estate-pool-house-drone-960-645a92d1.jpg";